import React from 'react';
import { histogram, range } from 'd3-array';
import some from 'lodash.some';

import {
  BarWrapperProps,
  DotWrapperProps,
  GraphElement,
  HistogramProps,
} from '../../types/graphs';
import { EntityScorePopoverProps } from '../../types/tooltips';
import { DriverDot } from '../../atoms/graphs/';
import { EntityScorePopover, EntityScoresPopover } from '../../atoms/tool-tips';
import { BarHistogram, DotHistogram } from './';

export interface Props extends HistogramProps {
  BarWrapper?: GraphElement<BarWrapperProps>;
  DotWrapper?: GraphElement<DotWrapperProps>;
  DotComponent?: any;
  barPadding?: number;
  dotPadding?: number;
  barThresholds?: number[];
  dotThresholds?: number[];
  tooltipProps?: (d: any) => EntityScorePopoverProps;
}

class DriverDistribution extends React.Component<Props, any> {
  static defaultProps: Props = {
    axisPadding: 10,
    barPadding: 1,
    dotPadding: 2,
    data: [],
    domain: [0, 100],
    isFocused: d => false,
    height: 200,
    showAxis: true,
    barThresholds: range(1, 100),
    dotThresholds: range(5, 100, 5),
    tooltipProps: d => ({ score: d }),
    width: 600,
    value: x => x,
    DotComponent: DriverDot,
  };

  public render() {
    const {
      BarWrapper,
      DotWrapper,
      barPadding,
      barThresholds,
      data,
      domain,
      dotPadding,
      dotThresholds,
      isFocused,
      value,
    } = this.props;

    const barisFocused = bar => some(bar, isFocused);
    const EntityDotComponent = ({
      className,
      cx,
      cy,
      data: { avatarUrl },
      muted,
      r,
      quartile,
    }) => {
      const { DotComponent } = this.props;
      return (
        <DotComponent
          {...{ avatarUrl, className, cx, cy, muted, quartile, r }}
        />
      );
    };

    const dotBuckets = histogram()
      .thresholds(dotThresholds)
      .value(value)
      .domain(domain)(data);
    const fullestBucketCount = Math.max(
      ...dotBuckets.map(bucket => bucket.length),
    );

    const scoresPopoverProps = (bucket: any) => ({
      scoreRange: [bucket.x0, bucket.x1],
      scoreCount: bucket.length,
    });

    const DRIVER_FACES_THRESHOLD = 6;
    const DRIVER_DOTS_LARGE_THRESHOLD = 30;

    if (fullestBucketCount < DRIVER_FACES_THRESHOLD) {
      return (
        <DotHistogram
          {...this.props}
          {...(DotWrapper ? DotWrapper : null)}
          memberPadding={dotPadding}
          thresholds={dotThresholds}
          DotComponent={EntityDotComponent}
          TooltipComponent={EntityScorePopover}
        />
      );
    }

    if (fullestBucketCount < DRIVER_DOTS_LARGE_THRESHOLD) {
      return (
        <DotHistogram
          {...this.props}
          {...(DotWrapper ? DotWrapper : null)}
          memberPadding={dotPadding}
          thresholds={dotThresholds}
          DotComponent={EntityDotComponent}
          TooltipComponent={EntityScorePopover}
        />
      );
    }

    return (
      <BarHistogram
        {...this.props}
        {...(BarWrapper ? BarWrapper : null)}
        memberPadding={barPadding}
        isFocused={barisFocused}
        thresholds={barThresholds}
        TooltipComponent={EntityScoresPopover}
        tooltipProps={scoresPopoverProps}
      />
    );
  }
}

export default DriverDistribution;
